@use "ui/styles/colors";
@use "ui/styles/fonts";

.container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background-color: colors.$gray05;
  border: 1px solid colors.$gray30;
  border-radius: 4px;
  transition: opacity 0.2s ease;

  &.dragging {
    opacity: 0.5;
  }

  &.dropTarget {
    border-color: colors.$blue;
  }
}

.dragHandle {
  cursor: grab;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    cursor: grabbing;
  }
}

.rowContent {
  flex: 1;
  display: flex;
  gap: 12px;
}
